//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The Age Classification to which a group requirement applies. All, Adults, or Children. */
export const AppliesToAgeClassification = {
    /** All */
    All: 0,

    /** Adults */
    Adults: 1,

    /** Children */
    Children: 2
} as const;

/** The Age Classification to which a group requirement applies. All, Adults, or Children. */
export const AppliesToAgeClassificationDescription: Record<number, string> = {
    0: "All",

    1: "Adults",

    2: "Children"
};

/** The Age Classification to which a group requirement applies. All, Adults, or Children. */
export type AppliesToAgeClassification = typeof AppliesToAgeClassification[keyof typeof AppliesToAgeClassification];
